export default __webpack_public_path__ + "static/media/owl_app_icon_backgroundless.4bbb32d9.svg";